import type { ProviderId, ProviderView } from '../../api/apiSchemas';
import { getPresentation } from '../../auth/providerPresentation';
import { Button } from '../ui';

export interface ProviderButtonProps {
  provider: ProviderView;
  disabled?: boolean;
  onActivate: (id: ProviderId) => void;
}

/**
 * Provider-agnostic login CTA (spec §7.2, §13). A single unified CTA per
 * provider; brand asset comes from the reviewed presentation mapping, never a
 * redrawn logo (spec §13.3).
 */
export function ProviderButton({ provider, disabled = false, onActivate }: ProviderButtonProps) {
  const presentation = getPresentation(provider.id);
  return (
    <Button
      type="button"
      variant="provider"
      fullWidth
      disabled={disabled}
      onClick={() => onActivate(provider.id)}
      data-provider={provider.id}
    >
      <img src={presentation.iconAsset} alt="" aria-hidden="true" width={18} height={18} />
      {presentation.loginLabel}
    </Button>
  );
}
